import moment from "moment"
import { AppConfigsActions, AppConfigsActionTypes, AppConfigsState } from "store/types/configs"

const initialState: AppConfigsState = {
  branchList: [],
  businessDate: moment(),
  gniTime: [],
}

const appConfigsReduce = (state = initialState, action: AppConfigsActions): AppConfigsState => {
  switch (action.type) {
    case AppConfigsActionTypes.FETCH_BRANCH_LIST:
      return {
        ...state,
        branchList: action.payload,
      }
    case AppConfigsActionTypes.FETCH_BUSINESS_DATE:
      return {
        ...state,
        businessDate: moment(action.payload, 'DD.MM.YYYY'),
      }
    default:
      return state
  }
}

export default appConfigsReduce